// extracted by mini-css-extract-plugin
export var statItem = "_h8-1";
export var statsRow = "_h8-0";